export default "__VITE_ASSET__BF61Gf7d__"